import { Routes } from '@angular/router';
import { SearchResultsType01Component } from './results-type01/search-results-type01.component';

export default [
    {
        path     : '',
        component: SearchResultsType01Component,
    },
    
] as Routes;
